/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DepartmentScopeFilter } from './departmentScopeFilter';


export interface DepartmentIncludeFilterItems { 
    relation?: DepartmentIncludeFilterItems.RelationEnum;
    scope?: DepartmentScopeFilter;
}
export namespace DepartmentIncludeFilterItems {
    export type RelationEnum = 'company' | 'businessUnit';
    export const RelationEnum = {
        Company: 'company' as RelationEnum,
        BusinessUnit: 'businessUnit' as RelationEnum
    };
}


